const ok = (value) => ({ ok: true, value });
const err = (error) => ({ ok: false, error });
const formatPrefix = (nodeName) => `[${nodeName}]`;
export function resolveCursorContext(args) {
    const { nodeName, state } = args;
    const currentThreadIndex = state.currentThreadIndex;
    if (currentThreadIndex === undefined || currentThreadIndex === null) {
        return err({
            code: 'missing_current_thread_index',
            message: `${formatPrefix(nodeName)} currentThreadIndex not set in graph state`,
        });
    }
    if (!state.mutableWorkflow) {
        return err({
            code: 'missing_mutable_workflow',
            message: `${formatPrefix(nodeName)} mutableWorkflow not set in graph state`,
        });
    }
    const threadSteps = state.mutableWorkflow.stepsByThreadIndex[currentThreadIndex];
    if (!threadSteps) {
        return err({
            code: 'missing_thread_steps',
            message: `${formatPrefix(nodeName)} Thread ${currentThreadIndex} not found in workflow`,
            details: { currentThreadIndex },
        });
    }
    const currentStepCounter = state.stepCounters[currentThreadIndex] ?? 0;
    return ok({
        currentThreadIndex,
        currentStepCounter,
        threadSteps,
    });
}
